(function () {
  'use strict';

  if (window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches) return;
  if (!('IntersectionObserver' in window)) return;

  function setup() {
    var targets = document.querySelectorAll(
      [
        'main .shopify-section .product-card',
        'main .shopify-section .collection-card',
        'main .shopify-section h1',
        'main .shopify-section h2',
        'main .shopify-section h3'
      ].join(', ')
    );

    if (!targets.length) return;

    var observer = new IntersectionObserver(function (entries) {
      entries.forEach(function (entry) {
        if (entry.isIntersecting) {
          entry.target.classList.add('pipona-visible');
          observer.unobserve(entry.target);
        }
      });
    }, { threshold: 0.15, rootMargin: '0px 0px -60px 0px' });

    targets.forEach(function (el, i) {
      el.classList.add('pipona-reveal');
      el.style.transitionDelay = (i % 4) * 70 + 'ms';

      var rect = el.getBoundingClientRect();
      if (rect.top < window.innerHeight && rect.bottom > 0) {
        // Ya esta visible al cargar la pagina: no la escondemos para evitar parpadeo
        el.classList.add('pipona-visible');
      } else {
        observer.observe(el);
      }
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', setup);
  } else {
    setup();
  }
})();
